import React, { useEffect } from 'react';
import './Blog.css';

import blogImage1 from '../assets/Blog1.jpg';
import blogImage2 from '../assets/Blog2.jpg';
import blogImage3 from '../assets/Blog3.jpg';

const Blog = () => {
  useEffect(() => {
    // Add entrance animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    // Observe elements for animation
    const elements = document.querySelectorAll('.blog-hero-title, .blog-hero-subtitle, .blog-card, .blog-cta');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const blogPosts = [
    {
      id: 1,
      title: "The Future of Digital Marketing in 2025",
      excerpt: "Explore the latest trends and technologies shaping the digital marketing landscape...",
      date: "January 15, 2025",
      author: "JN IT Team",
      image: blogImage1,
      category: "Digital Marketing"
    },
    {
      id: 2,
      title: "SEO Best Practices for Local Businesses",
      excerpt: "Learn how to optimize your local business website for better search engine rankings...",
      date: "January 10, 2025",
      author: "JN IT Team",
      image: blogImage2,
      category: "SEO"
    },
    {
      id: 3,
      title: "Social Media Strategies That Drive Results",
      excerpt: "Discover proven social media marketing strategies that increase engagement and conversions...",
      date: "January 5, 2025",
      author: "JN IT Team",
      image: blogImage3,
      category: "Social Media"
    }
  ];

  return (
    <section id="blog" className="blog-section">
      <div className="blog-hero">
        <div className="container">
          <h1 className="blog-hero-title">
            Latest Insights & Updates
            <span className="highlight"> from <span className="jn-letters"><span className="j-letter">J</span><span className="n-letter">N</span> <span className="i-letter">I</span><span className="t-letter">T</span></span></span>
          </h1>
          <p className="blog-hero-subtitle">
            Stay updated with the latest trends, tips, and insights from the world of digital marketing
          </p>
        </div>
      </div>

      <div className="container">
        <div className="blog-grid">
          {blogPosts.map((post) => (
            <article key={post.id} className="blog-card">
              <div className="blog-card-image">
                <img src={post.image} alt={post.title} />
                <span className="blog-category">{post.category}</span>
              </div>
              <div className="blog-card-content">
                <h3 className="blog-card-title">{post.title}</h3>
                <p className="blog-card-excerpt">{post.excerpt}</p>
                <div className="blog-card-meta">
                  <span className="blog-author">{post.author}</span>
                  <span className="blog-date">{post.date}</span>
                </div>
                <a href="#" className="blog-read-more">Read More</a>
              </div>
            </article>
          ))}
        </div>

        <div className="blog-cta">
          <h2>Want More Insights?</h2>
          <p>Subscribe to our newsletter for regular updates on digital marketing trends and tips.</p>
          <button className="cta-button">Subscribe Now</button>
        </div>
      </div>
    </section>
  );
};

export default Blog;
